/* Ventura: openschuivende zoekbalk met resultaten tijdens het typen (Shopify Predictive Search). */
(function () {
  var panel = document.querySelector('[data-vh-search]');
  var trigger = document.querySelector('[data-vh-search-open]');
  if (!panel || !trigger) return;

  var input = panel.querySelector('input[name="q"]');
  var results = panel.querySelector('[data-vh-search-results]');
  var status = panel.querySelector('[data-vh-search-status]');
  var closeButton = panel.querySelector('[data-vh-search-close]');
  var suggestUrl = panel.getAttribute('data-url') + '.json';
  var searchUrl = panel.getAttribute('data-search-url');
  var money = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: panel.getAttribute('data-currency') || 'EUR' });
  var timer = null;
  var controller = null;
  var activeIndex = -1;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('vh-search-open');
    window.requestAnimationFrame(function () { input.focus(); input.select(); });
  }

  function close(returnFocus) {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('vh-search-open');
    setExpanded(false);
    if (returnFocus) trigger.focus();
  }

  function options() {
    return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
  }

  function setExpanded(expanded) {
    input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (!expanded) {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }
  }

  function setActive(index) {
    var list = options();
    if (!list.length) return;
    activeIndex = (index + list.length) % list.length;
    list.forEach(function (option, i) { option.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
    input.setAttribute('aria-activedescendant', list[activeIndex].id);
    list[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  function option(id, href, inner, extraClass) {
    return '<a role="option" id="vh-opt-' + id + '" aria-selected="false" class="vh-sr-item' + (extraClass ? ' ' + extraClass : '') + '" href="' + escapeHtml(href) + '">' + inner + '</a>';
  }

  function render(data, terms) {
    var resources = (data && data.resources && data.resources.results) || {};
    var html = '';
    var n = 0;

    var queries = resources.queries || [];
    if (queries.length) {
      html += '<div class="vh-sr-group" role="group" aria-label="Suggesties">';
      queries.slice(0, 4).forEach(function (q) {
        html += option(n++, q.url, '<span class="vh-sr-query">' + (q.styled_text || escapeHtml(q.text)) + '</span>', 'vh-sr-q');
      });
      html += '</div>';
    }

    var products = resources.products || [];
    if (products.length) {
      html += '<div class="vh-sr-group" role="group" aria-label="Producten"><span class="vh-sr-label" aria-hidden="true">Producten</span>';
      products.forEach(function (p) {
        var image = p.featured_image && p.featured_image.url
          ? '<img src="' + escapeHtml(p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?' : '&') + 'width=120') + '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="vh-sr-noimg"></span>';
        var price = p.price ? money.format(Number(p.price)) : '';
        var soldOut = p.available === false ? ' <span class="vh-sr-sold">Uitverkocht</span>' : '';
        html += option(n++, p.url, image + '<span class="vh-sr-text"><span class="vh-sr-title">' + escapeHtml(p.title) + '</span><span class="vh-sr-meta">' + escapeHtml(price) + soldOut + '</span></span>', 'vh-sr-product');
      });
      html += '</div>';
    }

    var collections = resources.collections || [];
    var pages = resources.pages || [];
    if (collections.length || pages.length) {
      html += '<div class="vh-sr-group" role="group" aria-label="Collecties en pagina\'s"><span class="vh-sr-label" aria-hidden="true">Collecties en pagina\'s</span>';
      collections.forEach(function (c) { html += option(n++, c.url, '<span class="vh-sr-title">' + escapeHtml(c.title) + '</span>', 'vh-sr-link'); });
      pages.forEach(function (p) { html += option(n++, p.url, '<span class="vh-sr-title">' + escapeHtml(p.title) + '</span>', 'vh-sr-link'); });
      html += '</div>';
    }

    var total = products.length + collections.length + pages.length;
    var allUrl = searchUrl + '?q=' + encodeURIComponent(terms) + '&options%5Bprefix%5D=last';
    if (total === 0 && !queries.length) {
      html += '<p class="vh-sr-empty">Niets gevonden voor “' + escapeHtml(terms) + '”.</p>';
    }
    html += option(n++, allUrl, 'Alle resultaten voor “' + escapeHtml(terms) + '”', 'vh-sr-all');

    results.innerHTML = html;
    results.hidden = false;
    setExpanded(true);
    activeIndex = -1;
    status.textContent = total === 0 ? 'Geen resultaten' : (total === 1 ? '1 resultaat' : total + ' resultaten');
  }

  function search(terms) {
    if (controller) controller.abort();
    if (terms.length < 2) {
      results.innerHTML = '';
      results.hidden = true;
      setExpanded(false);
      status.textContent = '';
      return;
    }
    controller = 'AbortController' in window ? new AbortController() : null;
    var params = 'q=' + encodeURIComponent(terms) +
      '&resources[type]=product,collection,page,query' +
      '&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,tag';
    panel.classList.add('is-loading');
    fetch(suggestUrl + '?' + params, controller ? { signal: controller.signal } : {})
      .then(function (response) { return response.json(); })
      .then(function (data) { render(data, terms); })
      .catch(function (error) { if (!error || error.name !== 'AbortError') results.hidden = true; })
      .then(function () { panel.classList.remove('is-loading'); });
  }

  trigger.addEventListener('click', function (event) {
    event.preventDefault();
    if (panel.hidden) open(); else close(false);
  });
  if (closeButton) closeButton.addEventListener('click', function () { close(true); });

  input.addEventListener('input', function () {
    window.clearTimeout(timer);
    var terms = input.value.trim();
    timer = window.setTimeout(function () { search(terms); }, 180);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown') { event.preventDefault(); setActive(activeIndex + 1); }
    else if (event.key === 'ArrowUp') { event.preventDefault(); setActive(activeIndex - 1); }
    else if (event.key === 'Enter' && activeIndex > -1) {
      var list = options();
      if (list[activeIndex]) { event.preventDefault(); window.location.href = list[activeIndex].href; }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) close(true);
  });

  document.addEventListener('click', function (event) {
    if (panel.hidden) return;
    if (panel.contains(event.target) || trigger.contains(event.target)) return;
    close(false);
  });
})();
